module.exports = __webpack_public_path__ + "static/media/phone-office.1d8af99a.svg";